import React, { ReactNode } from 'react';
import { BlockContentContext } from '../BlockContent.utils';
import { ListComponent } from './ListComponent';

interface ListWrapperProps {
  children?: ReactNode;
  context?: BlockContentContext;
}

export const BulletListWrapper = ({ children, context }: ListWrapperProps) => (
  <ListComponent variant="bullet" context={context}>
    {children}
  </ListComponent>
);

export const NumberListWrapper = ({ children, context }: ListWrapperProps) => (
  <ListComponent variant="number" context={context}>
    {children}
  </ListComponent>
);

export const CheckListWrapper = ({ children, context }: ListWrapperProps) => (
  <ListComponent variant="check" context={context}>
    {children}
  </ListComponent>
);
export const CloseListWrapper = ({ children, context }: ListWrapperProps) => (
  <ListComponent variant="close" context={context}>
    {children}
  </ListComponent>
);
